import './styles.sass';

import React from 'react';

const Spinner = () => <div className="Explorer-Loader" />;

export default Spinner;
